import { FormHelper } from "./site/formhelper";
import { setupRegistration } from "./site/setupregistration";

declare global {
    interface Window {
        AJN: any;
    }
}

window.AJN = window.AJN || {};

window.AJN.sitejs = {
    FormHelper: FormHelper,
    setupRegistration: setupRegistration,
};
